export const API_PROVIDER_GROUP = "/api/providers/providerGroup"
export const API_PROVIDER_CONFIGURATION = "/api/providers/providerConfiguration"
export const API_TEMPLATE = "/api/providers/template"
export const API_IS_ACCOUNT_EXISTS = "/api/providers/isAccountExists"
export const API_IS_DROPLOCATION_INUSE = "/api/providers/isDropLocationInUse"



// WEBPACK FOOTER //
// ./src/Providers/urls.js